import { render } from "./PrintBirthdayCertificate.vue?vue&type=template&id=49d43b3c"
import script from "./PrintBirthdayCertificate.vue?vue&type=script&lang=js"
export * from "./PrintBirthdayCertificate.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__